module.exports = __webpack_public_path__ + "static/media/flowers_item_list.c57af002.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/flowers/flowers_item_list.csv
// module id = 767
// module chunks = 0